import { ASSOCIATION_ALERT_TYPES_ID } from '@constants/individualPortal/dashboard/dashboardModelTypes';

export const getAssociationAlertData = (partner, broker) => {
    // Default case - No association.
    const associationAlertData = {
        associationAlertTypeKey: ASSOCIATION_ALERT_TYPES_ID.NO_ASSOCIATION,
        name: ''
    };

    // no agent/broker is associated, but GAEP is associated.
    if  (partner && !broker) {
        associationAlertData.associationAlertTypeKey = ASSOCIATION_ALERT_TYPES_ID.PARTNER;
        associationAlertData.name = partner.organizationName;

    } else if (broker) {
        associationAlertData.associationAlertTypeKey = ASSOCIATION_ALERT_TYPES_ID.BROKER;
        associationAlertData.name = broker && `${broker.firstName} ${broker.lastName}`;
    }
    return associationAlertData;
};